const { CONSTANTS } = require('../../../../config')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function ssn ({ value, validationValue }) {
  if (!validationValue) return true

  let val = value
  if (!val) return false

  val = val
    .toString()
    .trim()

  // Get century sign
  const centurySign = val.indexOf('+') >= 0 ? '+' : '-'

  // Remove all characters except numbers
  val = val.replace(/[^0-9]/g, '')

  if (val.length === 12 && (val.substring(0, 2) === '19' || val.substring(0, 2) === '20')) {
    val = val.substring(2)
  }

  if (val.length !== 10) return false

  const currentDate = new Date()
  let year = val.substring(0, 2)
  const month = val.substring(2, 4)
  const day = val.substring(4, 6)
  let birthDate = new Date(parseInt(year, 10), (month - 1), parseInt(day, 10))
  let timeDiff = Math.abs(currentDate.getTime() - birthDate.getTime())
  let ageDate = new Date(timeDiff)
  let age = Math.abs(ageDate.getUTCFullYear() - 1970)

  const currentYear = currentDate.getFullYear()
  const currentCentury = parseInt(currentYear.toString().substr(0, 2))
  let century = currentCentury - 1

  if (age >= 100 && centurySign === '-') {
    century = currentCentury
  }

  year = `${century}${year}`
  birthDate = new Date(parseInt(year, 10), (month - 1), parseInt(day, 10))
  timeDiff = Math.abs(currentDate.getTime() - birthDate.getTime())
  ageDate = new Date(timeDiff)
  age = Math.abs(ageDate.getUTCFullYear() - 1970)

  // Check valid date
  /* istanbul ignore next: really hard to produce error */
  if (Object.prototype.toString.call(birthDate) !== '[object Date]' || isNaN(birthDate.getTime())) return false

  // Check if younger than min age
  if (age < CONSTANTS.SE?.AGE?.MIN) return false

  // Check if older than max age
  if (age > CONSTANTS.SE?.AGE?.MAX) return false

  // We actually got a customer who was born on the birth of time, Unix time that is,
  // so we can't parse that date in the next check since it will fail
  if (year !== '1970' && month !== '01' && day !== '01') {
    // Check valid date again with string. Organization numbers slips past if this isn't checked
    if (!Date.parse(`${year}-${month}-${day}`)) return false
  }

  // Declare luhn variables
  let sum = 0
  let i
  let digit

  const numDigits = val.length
  const parity = numDigits % 2

  // Check luhn algorithm
  for (i = 0; i < numDigits; i = i + 1) {
    digit = parseInt(val.charAt(i))

    if (i % 2 === parity) {
      digit *= 2
    }

    if (digit > 9) {
      digit -= 9
    }

    sum += digit
  }

  return (sum % 10) === 0
}

module.exports = { ssn }
